





































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Affix } from 'vue-affix'

@Component({
  components: {
    Affix
  }
})
export default class AdminInvoiceShowSideNavigation extends Vue {

  scrollPageTo(navEl) {
    let element = document.querySelector(`#${navEl}`)
    element.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

}
